<template>
  <Card class="border-2 border-dashed border-gray-200 rounded-2xl shadow-none mb-0">
    <CardHeader>
      <CardTitle>{{ title }}</CardTitle>
    </CardHeader>
    <CardContent class="flex items-center justify-center flex-col gap-4">
      <TButton color="indigo" @click="emit('button-click')">{{ buttonText }}</TButton>
      <p class="max-w-2xl text-center">{{ description }}</p>
    </CardContent>
  </Card>
</template>

<script setup lang="ts">
import Card from '@/components/ui/card/Card.vue';
import CardContent from '@/components/ui/card/CardContent.vue';
import CardHeader from '@/components/ui/card/CardHeader.vue';
import CardTitle from '@/components/ui/card/CardTitle.vue';

type EmptyResourceCardProps = {
  title: string;
  buttonText: string;
  description: string;
};
defineProps<EmptyResourceCardProps>();

const emit = defineEmits(['button-click']);
</script>
